import { render, staticRenderFns } from "./InstantROG.vue?vue&type=template&id=3075ea63&scoped=true&"
import script from "./InstantROG.vue?vue&type=script&lang=js&"
export * from "./InstantROG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3075ea63",
  null
  
)

export default component.exports